export const theme = {
  colors: {
    blue: `#014ea1`,
    red: `#ff0000`,
    light: `#ededed`,
    gray: `#aaaeaf`,
    white: `#fff`,
  },
};
